import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatomoTracker } from 'ngx-matomo-client';

import { AuthService } from './auth.service';
import { EmployerService } from './employer.service';

@Injectable({
  providedIn: 'root'
})
export class MatomoService {

  constructor(
    private translateService: TranslateService,
    private tracker: MatomoTracker,
    private authService: AuthService,
    private employerService: EmployerService,
  ) { }

  public initializeMatomo(): void {
    this.authService.getCurrentUser$().subscribe((user) => {
      if (user) {
        this.tracker.setUserId(user.email!);
      } else {
        this.tracker.resetUserId();
      }
    });

    this.employerService.getCurrentEmployerParty$().subscribe((party) => {
      if (party) {
        const customerNo = party?.identifications?.find((identification: any) => identification.type === 'CUSTOMER_NO');

        if (customerNo?.value) {
          this.tracker.setCustomDimension(1, customerNo.value);
        } else {
          this.tracker.deleteCustomDimension(1);
        }
      } else {
        this.tracker.deleteCustomDimension(1);
      }
    });

    this.tracker.setCustomDimension(2, this.translateService.getCurrentLang() || 'DE');
    this.translateService.onLangChange.subscribe(() => {
      this.tracker.setCustomDimension(2, this.translateService.getCurrentLang() || 'DE');
    });
  }
}
